$(document).on('click', '.search-link', function () {
    $('body').addClass('search-overlay-active');
});

$(document).on('click', '.search-overlay-close', function () {
    $('body').removeClass('search-overlay-active');
});